import { styled } from '@mui/system';
import { Button, MenuItem, Paper, Typography } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails/index';
import { WarningRounded } from '@mui/icons-material';
import RHFTextField from '#component/form/rhf/rhf-text-field';
import RHFRadioGroup from '#component/form/rhf/rhf-radio-group';

export const SettingsCnt = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing()
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  display: 'flex',
  flexDirection: 'column'
}));

export const PagesList = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  '& > div': {
    marginRight: theme.spacing(2)
  }
}));

export const DivIcon = styled('div')(() => ({
  color: '#0000008a'
}));

export const ButtonCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const SwitchCnt = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const SwitchAlign = styled('div')(() => ({
  alignSelf: 'center'
}));

export const StyledWarningIcon = styled(WarningRounded)(({ theme }) => ({
  color: '#FACE31',
  verticalAlign: 'middle',
  fontSize: 36,
  marginRight: theme.spacing()
}));

export const UserRoleField = styled(RHFRadioGroup)(({ theme }) => ({
  flexWrap: 'nowrap',
  '& $radioLabel': {
    [theme.breakpoints.down('sm')]: {
      minWidth: 115
    }
  }
}));

export const LastField = styled(RHFTextField)(({ theme }) => ({
  '& div div': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& div': {
      marginRight: theme.spacing(2)
    }
  },
  margin: '8px 0'
}));

export const StyledExpansionPanelDetails = styled(AccordionDetails)(() => ({
  display: 'block'
}));
